import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MuFieldPositionEnum } from '../../../models/interface/muFieldPosition.enum';

@Component({
  selector: 'app-mu-form-fieldset',
  templateUrl: './mu-form-fieldset.component.html',
  styleUrls: ['./mu-form-fieldset.component.sass'],
})
export class MuFormFieldsetComponent implements OnInit {
  @HostBinding('attr.title') attrTitle = '';
  @Input() customId: string;
  @Input() label: string;
  @Input() required: boolean;
  @Input() showLoading: boolean;
  @Input() customGridCol: number;
  @Input() customGridColMd: number;
  @Input() customGridColLg: number;
  @Input() customClass: string;
  @Input() withIcon: boolean;
  @Input() slimPadding: boolean;
  @Input() disabled: boolean;
  @Input() iconFeedback: boolean;
  @Input() hideError: boolean;
  @Input() position: MuFieldPositionEnum;
  @Input() tooltipText: string;
  @Input() positionMobile: boolean;
  @Input() labelSpacing: boolean;
  @HostBinding('class') class = 'mu-error-holder mu-field p-field p-col-';

  constructor() {
    /** */
  }

  ngOnInit(): void {
    this.class += (this.customGridColMd || 12) + ' p-md-';
    this.class += (this.customGridCol || 6) + '';
    this.class += this.position ? ' p-field-custom' : '';
    this.class += this.position ? ' mu-field-' + this.position : '';
    this.class += this.customGridColLg ? ` p-lg-${this.customGridColLg}` : '';
    this.class += ' ' + this.customClass;
    this.class += this.withIcon || this.iconFeedback ? ' mu-form-icon' : '';
    this.class += this.slimPadding ? ' mu-slim-padding' : '';
    this.class += this.disabled ? ' mu-field-disabled' : '';
    this.class += this.tooltipText ? ' mu-field-inline' : '';
    this.class += this.labelSpacing ? ' mu-field-label-spacing' : '';
    this.class += this.positionMobile ? ' mu-field-position-mobile' : '';
  }
}
